module.exports = __webpack_public_path__ + "static/design-system-w-13e121cbd7d0340143c8220a64e58f00.png";